import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const LeadsRating = () => {
  return (
    <SettingsMetaData propertyName={"leadsRating"} viewPropertyName={"leads Rating"} />
  );
};

export default LeadsRating;